/** Setzt document.title je Route (UX_KONZEPT.md §4 Punkt 14: "<Seite> — RMNC Energie"). */
import { useEffect } from "react"

export function useDocumentTitle(seite: string): void {
  useEffect(() => {
    const vorher = document.title
    document.title = `${seite} — RMNC Energie`
    return () => {
      document.title = vorher
    }
  }, [seite])
}
